import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { FormGroup, FormControl, NgControl } from '@angular/forms';

@Directive({
	selector: '[cmvTrimOnBlur]',
})
export class TrimOnBlurDirective {
	@Input() formGroup: FormGroup;

	constructor(private el: ElementRef, private control: NgControl) {}

	@HostListener('blur')
	onBlur() {
		const value = this.el.nativeElement.value.trim();
		this.control.control.setValue(value);
	}
}
